export default __webpack_public_path__ + "static/media/freeIcon_lightBorder_color.8f186f09.svg";